import { Button, Form, Select, Spin } from 'antd';
import moment from 'moment';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ReactSVG } from 'react-svg';
import { DAY_FORMAT } from '../../../constants';
import { selectAllRoutePlans } from '../../../modules/route-plans/stores/slice';
import { doGetRoutePlans } from '../../../modules/route-plans/stores/thunk';

const BulkAddToRoutePlanForm = ({ form, isFetching, handleSubmit, handleCancel }) => {
  const dispatch = useDispatch();
  const routePlans = useSelector((state) => selectAllRoutePlans(state));

  useEffect(() => {
    dispatch(doGetRoutePlans());
  }, []);

  const options = routePlans.map((item) => {
    return {
      value: item.id,
      label: item.name + ' - ' + moment(item.deliveryDate).format(DAY_FORMAT),
    };
  });
  return (
    <Spin spinning={isFetching}>
      <div className="BulkAddToRoutePlanForm">
        <Form form={form} scrollToFirstError layout="vertical" hideRequiredMark colon={false} onFinish={handleSubmit}>
          <div className="FormContent">
            <Form.Item label="Select Route Plan" name="routePlanId" rules={[{ required: true, message: 'Required' }]}>
              <Select size="large" placeholder="Select Route Plan" options={options} />
            </Form.Item>
          </div>
          <div className="FormFooter">
            <div className="Left"></div>
            <div className="Right">
              <Button key="cancel" onClick={handleCancel}>
                Cancel
              </Button>
              <Button htmlType="submit" type="primary">
                Confirm
                <ReactSVG className="icon" src="/icons/submit.svg" />
              </Button>
            </div>
          </div>
        </Form>
      </div>
    </Spin>
  );
};

export default BulkAddToRoutePlanForm;
